module.exports = __webpack_public_path__ + "img/bttn-magnify-off.72e50c9c.svg";